import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-kenya-money-market.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorKenyaMoneyMarket = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorKenyaMoneyMarket, _super);
    function CalculatorKenyaMoneyMarket(element) {
        return _super.call(this, element) || this;
    }
    CalculatorKenyaMoneyMarket.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputPurchasePrice = this.element.querySelector('input[name=purchase_price]');
        this.inputDeposit = this.element.querySelector('input[name=deposit_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalBalance = this.element.querySelector('.js-ending-balance');
        this.totalInterestEarned = this.element.querySelector('.js-interest-earned');
        this.totalDeposit = this.element.querySelector('.js-regular-deposit');
        this.totalInterest = this.element.querySelector('.js-total-interest');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-kenya-money-market__result--terms');
        this.containerSchedule = Array.from(document.querySelectorAll('.js-amort-schedule-kenya-money-market'));
        this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorKenyaMoneyMarket.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalBalance.innerHTML = "-";
            _this.totalInterestEarned.innerHTML = "-";
            _this.totalDeposit.innerHTML = "-";
            _this.totalInterest.innerHTML = "-";
        });
    };
    CalculatorKenyaMoneyMarket.prototype.calculate = function () {
        var initialInvestment = parseFloat(this.inputPurchasePrice.value) || 0;
        var monthlyDeposit = parseFloat(this.inputDeposit.value) || 0;
        var nominalAnnualRate = parseFloat(this.inputInterest.value) || 0;
        var months = parseInt(this.inputTerm.value) || 0;
        var taxRate = 0.15;
        var monthlyRate = nominalAnnualRate / 100 / 12;
        var calculatedEAIR = (Math.pow(1 + monthlyRate, 12) - 1) * 100;
        var balance = initialInvestment;
        var totalGrossInterest = 0;
        var totalNetInterest = 0;
        var totalDeposits = 0;
        var resultRows = [];
        for (var i = 1; i <= months; i++) {
            var grossInterest = balance * monthlyRate;
            var tax = grossInterest * taxRate;
            var netInterest = grossInterest - tax;
            totalGrossInterest += grossInterest;
            totalNetInterest += netInterest;
            balance += netInterest + monthlyDeposit;
            totalDeposits += monthlyDeposit;
            resultRows.push({
                month: i,
                grossInterest: grossInterest,
                tax: tax,
                netInterest: netInterest,
                endingBalance: balance,
                cumulativeDeposit: totalDeposits,
            });
        }
        var totalInvested = initialInvestment + totalDeposits;
        // Update UI
        this.totalInterestEarned.innerHTML = this.roundFormatter(totalNetInterest, 2, true);
        this.totalBalance.innerHTML = this.roundFormatter(balance, 2, true);
        this.totalDeposit.innerHTML = this.roundFormatter(totalInvested, 2, true);
        this.totalInterest.innerHTML = this.roundFormatter(calculatedEAIR, 2) + "%";
        this.calculateAmort();
    };
    CalculatorKenyaMoneyMarket.prototype.calculateAmort = function () {
        console.log('Amort Schedule for Investment');
        this.containerSchedule.forEach(function (item) { return item.innerHTML = ''; });
        var principal = parseFloat(this.inputPurchasePrice.value) || 0;
        var deposit = parseFloat(this.inputDeposit.value) || 0;
        var rate = parseFloat(this.inputInterest.value) || 0;
        var term = parseInt(this.inputTerm.value) || 0;
        var taxRate = 0.15;
        var monthlyRate = rate / 100 / 12;
        var balance = principal;
        var totalGrossInterest = 0;
        var totalNetInterest = 0;
        var totalDeposits = 0;
        var rows = "";
        for (var i = 1; i <= term; i++) {
            var grossInterest = balance * monthlyRate;
            var tax = grossInterest * taxRate;
            var netInterest = grossInterest - tax;
            totalGrossInterest += grossInterest;
            totalNetInterest += netInterest;
            var beginningBalance = balance;
            balance += netInterest + deposit;
            totalDeposits += deposit;
            rows += "\n\t\t\t\t<tr>\n\t\t\t\t\t<td>" + i + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(beginningBalance, 0)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(grossInterest, 2)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(tax, 2)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(netInterest, 2)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(totalNetInterest, 2)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(balance, 0)) + "</td>\n\t\t\t\t\t<td>" + this.formatter(this.round(totalDeposits, 0)) + "</td>\n\t\t\t\t</tr>\n\t\t\t";
        }
        var totalInvested = principal + totalDeposits;
        var table = "\n\t\t\t<table class=\"table table--blue table-responsive table-striped\">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Month</th>\n\t\t\t\t\t\t<th>Beginning Balance</th>\n\t\t\t\t\t\t<th>Gross Interest Earned</th>\n\t\t\t\t\t\t<th>15% Withholding Tax</th>\n\t\t\t\t\t\t<th>Net Interest</th>\n\t\t\t\t\t\t<th>Total Interest Earned</th>\n\t\t\t\t\t\t<th>Ending Balance</th>\n\t\t\t\t\t\t<th>Total Additional Regular Deposit</th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t" + rows + "\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t";
        var fragment = document.createRange().createContextualFragment(table);
        this.containerSchedule.forEach(function (container) { return container.appendChild(fragment.cloneNode(true)); });
    };
    CalculatorKenyaMoneyMarket.prototype.PV = function (rate, nper, pmt, fv, type) {
        var pv_value = 0;
        rate = parseFloat(rate);
        nper = parseFloat(nper);
        pmt = parseFloat(pmt);
        fv = parseFloat(fv);
        if (nper == 0) {
            alert("Why do you want to test me with zeros?");
            return (0);
        }
        if (rate == 0) { // Interest rate is 0
            pv_value = -(fv + (pmt * nper));
        }
        else {
            var x = Math.pow(1 + rate, -nper);
            var y = Math.pow(1 + rate, nper);
            pv_value = -(x * (fv * rate - pmt + y * pmt)) / rate;
        }
        return pv_value;
    };
    CalculatorKenyaMoneyMarket.prototype.FV = function (rate, nper, pmt, pv, type) {
        var pow = Math.pow(1 + rate, nper), fv;
        pv = pv || 0;
        type = type || 0;
        if (rate) {
            fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow;
        }
        else {
            fv = -1 * (pv + pmt * nper);
        }
        return fv;
    };
    CalculatorKenyaMoneyMarket.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorKenyaMoneyMarket.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorKenyaMoneyMarket.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorKenyaMoneyMarket.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorKenyaMoneyMarket;
}(Base));
export { CalculatorKenyaMoneyMarket };



//////////////////
// WEBPACK FOOTER
// ./components-kenya/calculator-kenya-money-market/calculator-kenya-money-market.component.ts
// module id = 784
// module chunks = 0